/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/vin/VINScannerUIResult.yaml
import { ToJsonConfiguration } from '../../common/JsonSerializationTypes';
import { TextPatternScannerResult } from '../../text_pattern/TextPatternScannerTypes';
import { VinBarcodeResult } from '../../vin/VinScannerTypes';
/**
Configuration of the generic text scanner RTU UI result.
*/
export class VinScannerUiResult {
    /** @param source {@displayType `DeepPartial<VinScannerUiResult>`} */
    constructor(source = {}) {
        if (source.textResult !== undefined) {
            this.textResult = new TextPatternScannerResult(source.textResult);
        }
        else {
            throw new Error('textResult must be present in constructor argument');
        }
        if (source.barcodeResult !== undefined) {
            this.barcodeResult = new VinBarcodeResult(source.barcodeResult);
        }
        else {
            throw new Error('barcodeResult must be present in constructor argument');
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            textResult: this.textResult.serialize(config),
            barcodeResult: this.barcodeResult.serialize(config),
        };
    }
}
//# sourceMappingURL=VinScannerUiResult.js.map